const Loading = ({ loading }) => {
  return (
    <div className="loading absfull flex_center" trans="500" loading={loading ? 1 : 0}>
      LOADING
    </div>
  );
};

export default Loading;
